export const termText = `Agradecemos sua visita ao Sistema Agro e seu interesse em nossos serviços. Sua
privacidade é extremamente importante para nós e queremos que você se sinta à vontade.
Todos os esforços serão efetuados no sentido de proteger seus dados pessoais que forem
coletados, processados e utilizados durante a sua visita.
Ao acessar o Sistema Agro, você declara aceitar esta Política ("Política"). Caso não
concorde com esta Política, não avance para as outras páginas. Na hipótese de não
avançar, informamos a inviabilidade do início da prestação dos serviços através deste
sistema.

DAS DENOMINAÇÕES

Para efeitos desta Política de Uso, Privacidade e LGPD - Sistema Agro, as expressões
abaixo têm os seguintes significados:
“Você”: significa o cliente Lockton, segurado no seguro contratado no Sistema Agro,
representado pelo Usuário que tem autoridade para aceitar esta Política; Significa também
o Usuário, quando relacionado aos dados pessoais de sua titularidade e sua autonomia
para tomar decisões em nome do cliente Lockton.
“Usuário(s)”: Significa a pessoa natural (pessoa física) indicada pelo cliente Lockton para
utilização do Sistema Agro.
“Nós”: Significa a Lockton, empresa prestadora de serviços de corretagem de seguros,
proprietária deste sistema e responsável pela coleta dos dados para a execução da
colocação de seguros, administração das apólices e regulação de sinistros.

DA POLÍTICA DE PRIVACIDADE E SISTEMA AGRO

(1) A Política de Uso, Privacidade e LGPD - Sistema Agro, assim como as informações e
materiais contidos no Sistema Agro, estão sujeitas a atualização periódica, sem que seja
necessária notificação aos usuários. Portanto, a Lockton o convida a consultá-las
regularmente.
(2) Ao final deste documento, você encontrará a data da última atualização da Política.
(3) O conteúdo do Sistema Agro é criado e distribuído pela Lockton.
(4) Esta Política se aplica a quaisquer informações obtidas pela Lockton por meio do uso
que você faz do Sistema Agro, mas não se aplica a nenhum outro site, controlado por
terceiros não relacionados com a Lockton, mesmo que possa ser acessado por meio de
referências eletrônicas ("links") disponíveis no Sistema Agro ("Sites de Terceiros"). Por
favor, verifique as Política de Uso, Privacidade e LGPD dos Sites de Terceiros, pois a
Lockton não é responsável pelo conteúdo ou pelas práticas de privacidade destes e nem
exerce influência sobre eles.
(5) Os termos desta Política estão sujeitos a isenção de responsabilidade ou outros
termos contratuais que você tenha celebrado e/ou venha a celebrar com a Lockton como,
por exemplo, outras políticas de privacidade (prevalecendo sempre o que for mais
específico), leis ou regulamentos aplicáveis.

DA CONFIDENCIALIDADE DAS INFORMAÇÕES, DIVULGAÇÃO E
COMPARTILHAMENTO

(6) A Lockton compromete-se a manter a confidencialidade das informações pessoais,
técnicas e empresariais obtidas através dos usuários. Nesse sentido, a Lockton
desenvolve esta Política para descrever o tipo de informação a ser obtida dos Usuários, a
maneira como tais informações serão coletadas e os propósitos pelos quais a Lockton
coletará, compartilhará e divulgará as informações. A Lockton explica, ainda, as
precauções que serão tomadas para manter as informações confidenciais.
(7) A Lockton poderá compartilhar as suas informações com funcionários,
representantes, parceiros, agentes do mercado de seguros e afiliados, dentro ou fora de
seu país de residência, caso isso seja necessário para a execução do contrato de
prestação de serviços ou cumprimento de determinações das políticas do grupo, bem
como para a Susep (Superintendência de Seguros Privados), quando solicitada para tanto,
nos termos da lei e regulamentos.
(8) Ao transferir dados pessoais internacionalmente, certificamo-nos de que estamos
cumprindo as leis e regulamentos aplicáveis, por exemplo, celebrando contratos que
assegurem que os destinatários de suas informações mantenham um nível adequado de
proteção destas.
(9) Nossos funcionários, representantes e outros fornecedores que acessem dados
pessoais obtidos por meio do Sistema Agro, estão obrigados a respeitar a privacidade e
proibidos de fazerem uso dessas informações para uso distinto dos definidos por esta
política.
(10) Também podemos divulgar suas informações a agências ou entidades
governamentais, autoridades reguladoras ou outras pessoas, conforme exigido ou
permitido pela legislação e regulamentação aplicáveis.

DA COLETA DE DADOS

(11) Ao visitar o Sistema Agro, nosso servidor registra automaticamente seu IP a partir do
computador que você está utilizando, o tipo e versão do software de navegação utilizado,
as páginas da web que você acessou dentro de nossa plataforma, incluindo data e período.
(12) Além disso, coletamos dados pessoais fornecidos por você por meio do Sistema Agro,
de acordo com a Lei Geral de Proteção de Dados (LGPD), por exemplo, quando você insere
seus dados pessoais, como nome, endereço, e-mail, número de telefone e dados técnicos
de seguros, para subsidiar o pedido de emissão da apólice, etc.
(13) O seu consentimento para o processamento de dados pessoais é para que
consigamos prestar os serviços de corretagem de seguros. Você pode retirar seu
consentimento para tal processamento a qualquer momento, no entanto, se você retirar
seu consentimento, isso afetará nossa capacidade de administrar seus seguros, bem
como a capacidade de outros participantes do mercado de seguros de fazê-lo, podendo
afetar o pagamento de sinistros ou manutenção de validade da apólice ou contrato de
saúde.
(14) Manteremos seus dados pessoais pelo tempo que for necessário e para o propósito
para o qual foram originalmente coletados. Em particular, os dados serão mantidos em
nossos arquivos de forma que se atenda aos prazos legais e regulamentares. Em algumas
circunstâncias, você pode nos solicitar a exclusão de seus dados pessoais, respeitadas as
limitações previstas pela legislação securitária.
(15) A Lockton utilizará seus dados pessoais, e os dados técnicos da colocação do seguro
para (i) fins de administração técnica, (ii) pesquisa, aperfeiçoamento e/ou
desenvolvimento de ferramentas antifraude e demais funcionalidades do Sistema Agro, (iii)
confirmar ou corrigir as informações que temos sobre o Usuário, (iv) realização de
cotações e políticas de preços, (v) responder suas consultas, (vi) atender suas solicitações
e realizar transações relacionadas às suas solicitações, (vii) processar requerimentos
relacionados a avisos de sinistros, (viii) para verificação ou validação fins relacionados ao
seu seguro, (ix) Para entrarmos em contato por e-mail, ou por qualquer outro meio de
comunicação que seu dispositivo seja capaz de receber, nos termos da lei e para fins
comerciais razoáveis, incluindo fins relacionados a sua apólice conosco, (x) para fins
comerciais, (xi) dar cumprimento às leis aplicáveis, e (xii) bem como administração e
marketing de clientes e usuários ou ainda para melhorar os serviços prestados e a
experiência dos Usuários (“Objetivos”).
(16) Utilizamos seus dados pessoais e técnicos de seguro para informá-lo sobre nossos
serviços exclusivamente segundo as leis e regulamentos aplicáveis.
(17) Também coletamos, usamos e compartilhamos dados agregados, como dados
estatísticos ou demográficos, para finalidades como estudo de mercado etc. Os dados
agregados podem ser derivados de seus dados pessoais, mas não são considerados dados
pessoais na forma da lei, pois esses dados não revelam sua identidade direta ou
indiretamente. No entanto, caso combinemos ou conectemos dados agregados com seus
dados pessoais, de forma que possam ser identificáveis, direta ou indiretamente,
trataremos tais dados combinados como dados pessoais que serão usados de acordo
com esta política.
(18) O Sistema Agro não visa coletar dados pessoais de pessoas com menos de 18
(dezoito) anos de idade, já que estas devem ter a autorização dos pais ou de seu tutor legal
antes de fornecerem dados pessoais por intermédio da Sistema Agro.
(19) Nomeamos um responsável pela de proteção de dados, que tem como atribuições
prestar esclarecimento, receber reclamações e supervisionar o cumprimento da LGPD e
das questões relacionadas a este aviso de privacidade. Se tiver alguma dúvida sobre o
processamento de seus dados pessoais, entre em contato pelo nosso telefone + 55 11
3371-9309 ou pelo e-mail dpobr@lockton.com.

DA FINALIDADE PARA A COLETA DE DADOS

(20) Apresentamos abaixo os propósitos para os quais podemos usar seus dados
pessoais: (a) Gestão de Relacionamento: Para fornecer a você informações (por exemplo,
a respeito de produtos e serviços) solicitadas por você e tomar medidas conforme sua
solicitação antes de formalizar em um contrato; (b) Cotação: Cadastramento como
cliente, incluindo possíveis verificações de fraude, sanções, crédito e lavagem de dinheiro;
Avaliação dos riscos a serem cobertos; (c) Administração da apólice: Atendimento ao
cliente, incluindo comunicação com você e envio de atualizações; (d) Processamento de
Sinistros: Gerenciando sinistros de seguro; (e) Renovações: Contatar o segurado para
renovar a apólice de seguro; Avaliação dos riscos a serem cobertos; (f) Outras finalidades
fora do ciclo de validade do seguro, mas necessárias para a prestação de seguro durante o
período do ciclo de vida do seguro: Cumprimento de obrigações legais e regulamentares;
Modelagem geral de risco; Transferência de negócios, aquisições ou vendas, e
reorganizações da empresa; (g) Serviços de consultoria: Modelagem geral de risco; Análise
como parte do conselho de consultoria específica; (h) Gestão de sites: Usar a análise de
dados para melhorar nosso sistema, marketing, relacionamento com clientes e
experiências, inclusive para garantir que o conteúdo de nosso website seja apresentado da
maneira mais eficaz para você e seu dispositivo; (i) Marketing: Para fazer sugestões e
recomendações para você sobre produtos ou serviços que possam ser de seu interesse,
fornecer informações sobre o setor ou convidá-lo para eventos; Para medir e compreender
a eficácia do marketing que servimos para você e para os outros e para entregar o marketing
relevante para você.
(21) Observe que, além das divulgações que identificamos em relação a cada finalidade,
também podemos divulgar dados pessoais para nossos prestadores de serviços,
contratados, agentes, advogados, e empresas do grupo que realizam atividades em nosso
nome.
(22) Observe que podemos processar seus dados pessoais sem o seu conhecimento ou
consentimento, em conformidade com as regras acima, quando isso for exigido ou
permitido.

DA SEGURANÇA DOS USUÁRIOS

(23) ID do usuário/Senha. A Lockton solicitará a utilização das informações de
identificação de Usuário (“ID do usuário”) e senhas. Você é o único responsável por
impedir a divulgação ou fornecimento do ID de seu Usuário e das suas senhas a terceiros.
Permitir que outra pessoa utilize seu ID do usuário e suas respectivas senhas, utilizar o ID
do usuário e as senhas de outra pessoa, ou tentar acessar recursos que não está
autorizado a acessar constituem violações a estes termos e condições. Acessar um
computador sem autorização ou exceder o limite de acesso autorizado é uma violação das
normas de segurança e pode constituir crime nos termos da lei.
(24) Estabelecemos procedimentos para lidar com qualquer suspeita de violação de dados
pessoais e notificaremos você e qualquer regulador aplicável sobre uma violação de seus
dados, caso venha a ocorrer.
(25) Que medidas de segurança foram implantadas para proteger as suas informações? A
Lockton adota medidas de segurança técnicas e organizacionais para proteger os dados
pessoais contra acesso não autorizado, manipulação acidental ou intencional, perda e
destruição.
(26) É importante ressaltar que a Lockton não se responsabiliza pela segurança de suas
informações enquanto estiverem em trânsito na internet até chegarem ao Sistema Agro.
Se for de sua preferência a Lockton poderá se utilizar de outro meio de comunicação para
contato.

DO USO DA PLATAFORMA E PROCEDIMENTOS DE EMISSÃO DE APÓLICES

(27) Inexistência de garantia pela Lockton. Embora a Lockton intermedeie a contratação de
seguros por meio do Sistema Agro, você deve estar ciente de que as emissões das apólices
são realizadas pelas Seguradoras e dentro dos critérios técnicos e de apetite de risco de
cada seguradora. A Lockton não tem poder de decisão sobre tais controles, de forma que
caso haja algum problema na plataforma ou nos e-mails de recebimento das
confirmações, pedimos que você nos contate imediatamente, pelos canais comerciais
existentes, para que possamos entrar em contato com a Seguradora o mais rápido
possível.
(28) Você é o único responsável por revisar a documentação e informações inseridas no
Sistema Agro de forma que qualquer dano decorrente de informação imprecisa,
incompleta ou errada não será de responsabilidade da Lockton. Caso você tenha dúvidas
sobre o seguro e as suas coberturas, limites ou outros termos e condições, ou
preocupações de que não consideramos suas instruções corretamente, entre em contato
conosco imediatamente.
(29) Você deve fornecer todas as informações relacionadas ao risco do seu negócio que
possam afetar o julgamento da Seguradora na aceitação do risco, a determinação do
prêmio do seguro e as condições/ cláusulas da apólice. Se todas as referidas informações
não forem divulgadas, a Seguradora poderá anular o contrato de seguro desde o início de
sua vigência ou mesmo não acatar sinistros ocorridos, em conformidade com artigo 766,
do Código Civil.
(30) Da Remuneração da Lockton (Resolução CNSP 382). A Lockton obedece aos
princípios preconizados pela Susep quanto às práticas de conduta adotadas pelas
sociedades corretoras de seguros, no que se refere ao relacionamento com o cliente, em
particular os princípios quanto à transparência de remuneração.
(31) Como seu corretor de seguros eleito, nós recebemos nossas receitas de várias
maneiras. Em geral, nós receberemos remuneração, tanto em forma de pagamento de
comissão diretamente feito pela seguradora, ou por honorários cobrados diretamente dos
clientes ou ainda por uma combinação entre comissão e honorários.
(32) A sistemática da remuneração pelas apólices emitidas por solicitação neste sistema
será apresentada pelo Lockton ao cliente.
(33) O Usuário garante a veracidade de todos os Dados imputados na Plataforma LSP,
tendo ciência de sua responsabilidade por declarações falsas, guarda e não divulgação de
tais Dados a qualquer terceiro.
(34) Para informações técnicas adicionais sobre esta ferramenta, por favor, entre em
contato com seu executivo de relacionamento que direcionará para a área responsável e
lhe apresentará uma resposta.
(35) Eleição de Foro Eventual demanda judicial envolvendo controvérsias, disputas ou o
descumprimento do presente Política, deverão ser processadas no Foro da Comarca da
Capital do Estado de São Paulo.

DAS VEDAÇÕES

(36) Quais ações são vedadas aos usuários do Sistema Agro? Os usuários não podem
praticar quaisquer atos ilícitos ou que violem a legislação aplicável e/ou direitos da Lockton
ou de terceiros, bem como atos de coação, ameaça, constrangimento, violação de
sigilo/privacidade, discriminação de qualquer natureza (origem, raça, sexo, orientação
sexual, idade e cor) contra os demais Usuários ou incitação ao ódio e a prática de crimes.
(37) Assim como quaisquer atos que sejam prejudiciais direta ou indiretamente à Lockton,
incluindo violação aos direitos de imagem, marca, logo, propriedade intelectual,
privacidade e conexos a estes. O Usuário será inteiramente responsável por todo e
qualquer dano, direto ou indireto a que der causa em decorrência do descumprimento dos
termos de Política.
(38) É resguardado à Lockton o direito de excluir a conta do Usuário por critérios internos
e/ou para cumprimento da legislação aplicável.

DA PROPRIEDADE INTELECTUAL, MARCAS E PATENTES

(39) Propriedade Intelectual. "Propriedade Intelectual" significa qualquer dado, patente,
direito autoral, direito de banco de dados, direito moral, direito de design, design registrado,
marca comercial, marca de serviço, nome de domínio, know-how, metodologias,
conceitos, técnica, relatório, modelo de utilidade, design não registrado ou, quando
pertinente, qualquer pedido de tal direito ou outro direito de propriedade industrial ou
intelectual existente em qualquer lugar do mundo.
(40) Embora você deva manter a propriedade de todos os documentos de contrato de
seguro físico, recibos e quaisquer outros documentos criados por nós na execução dos
Serviços ("Documentos de Colocação"), a propriedade de todos os Direitos de
Propriedade Intelectual em quaisquer Documentos de Colocação deve pertencer e
permanece com a Lockton.
(41) Todas as atividades realizadas pela Lockton, conforme descritas neste documento,
são fornecidas pela Lockton, para seu uso exclusivo e todos os dados, recomendações,
propostas, relatórios e outras informações fornecidas por nós em conexão com nossos
serviços são para seu uso exclusivo. Você concorda em não permitir o acesso de terceiros
a essas informações sem nossa expressa permissão por escrito.`;

export const termTitle = `POLÍTICA DE USO, PRIVACIDADE E LGPD - SISTEMA AGRO - LOCKTON BRASIL CONSULTORIA E CORRETORA DE SEGUROS LTDA E AFILIADAS`;
